import {
  Text,
  FormControl,
  FormLabel,
  NumberInput,
  NumberInputField,
  Input,
  Stack,
  HStack,
  Box,
  Button,
  IconButton,
  Flex
} from '@chakra-ui/react'
import { CloseIcon } from '@chakra-ui/icons'

// Campos de "Estaciones de control de plagas"
const FIELDS = [
  { key: 'rodenticide_stations', label: 'Cantidad de estaciones rodenticidas' },
  { key: 'non_toxic_traps', label: 'Cantidad de trampas no tóxicas' },
  { key: 'pigeon_cages', label: 'Cantidad de jaulas de palomas' },
  { key: 'tuv_equipment', label: 'Cantidad de equipos TUV' }
]

const PestControlStationsForm = ({ formik }) => {
  const values = formik.values.pest_control_stations || {}

  const handleChange = (key, valueString) => {
    const parsed = parseInt(valueString, 10)
    formik.setFieldValue('pest_control_stations', {
      ...values,
      [key]: Number.isNaN(parsed) ? 0 : parsed
    })
  }

  const others = Array.isArray(values.others) ? values.others : []

  const setOthers = (next) => {
    formik.setFieldValue('pest_control_stations', {
      ...values,
      others: next
    })
  }

  const handleOthersChange = (index, key, value) => {
    setOthers(
      others.map((item, i) => (i === index ? { ...item, [key]: value } : item))
    )
  }

  const handleAddOther = () => {
    setOthers([...others, { name: '', quantity: 0 }])
  }

  const handleRemoveOther = (index) => {
    setOthers(others.filter((_, i) => i !== index))
  }

  return (
    <>
      <Text fontSize="20px" fontWeight="bold" color="#36355F" pt="50px">
        Estaciones de control de plagas
      </Text>
      <Stack spacing={4}>
        {FIELDS.map((field) => (
          <FormControl id={field.key} key={field.key}>
            <FormLabel>{field.label}</FormLabel>
            <NumberInput
              min={0}
              value={values[field.key] ?? 0}
              onChange={(valueString) =>
                handleChange(field.key, valueString)
              }
            >
              <NumberInputField name={field.key} placeholder="0" />
            </NumberInput>
          </FormControl>
        ))}
        <FormControl id="others">
          <FormLabel>Otros</FormLabel>
          <Stack spacing={3}>
            {others.map((item, index) => (
              <HStack key={index} align="center" spacing={4}>
                <Box flex="1">
                  <Input
                    value={item.name ?? ''}
                    onChange={(e) =>
                      handleOthersChange(index, 'name', e.target.value)
                    }
                    placeholder="Cuál otro"
                  />
                </Box>
                <Box w="140px">
                  <NumberInput
                    min={0}
                    value={item.quantity ?? 0}
                    onChange={(valueString) => {
                      const parsed = parseInt(valueString, 10)
                      handleOthersChange(
                        index,
                        'quantity',
                        Number.isNaN(parsed) ? 0 : parsed
                      )
                    }}
                  >
                    <NumberInputField placeholder="Cantidad" />
                  </NumberInput>
                </Box>
                <IconButton
                  aria-label="Eliminar otro"
                  icon={<CloseIcon />}
                  size="sm"
                  colorScheme="red"
                  variant="ghost"
                  onClick={() => handleRemoveOther(index)}
                />
              </HStack>
            ))}
          </Stack>
          <Flex pt={3}>
            <Button
              bg="white.500"
              color="black"
              _hover={{ bg: 'white.600' }}
              border="1px"
              borderColor="black"
              onClick={handleAddOther}
            >
              + Agregar otro
            </Button>
          </Flex>
        </FormControl>
      </Stack>
    </>
  )
}

export default PestControlStationsForm
